import {
  EscalationAssignedNotificationInterface,
  NotificationBaseInterface,
  NotificationInterface,
  NotificationType,
  OrgInterface,
  EscalationInterface,
} from "@swivl-mono/types";

import { APIService } from "../Service/API.Service";

// LINK apps/server/src/API/Notifications/Notifications.Controller.ts
export class NotificationsAPI {
  static async getNotifications(
    orgId: number,
    memberId: number,
    activeOnly: boolean = true,
    take: number = 100,
    page = 1,
  ): Promise<NotificationInterface[]> {
    return APIService.Server.get<NotificationInterface[]>(`/notifications/org/${orgId}/member/${memberId}`, { take, page, activeOnly });
  }

  static async create(orgId: number, notification: Partial<NotificationBaseInterface>): Promise<NotificationBaseInterface> {
    return APIService.Server.post<NotificationBaseInterface>(`/notifications/org/${orgId}/notification`, { notification });
  }
  static async acknowledge(
    orgId: number,
    notificationId: number,
    updatedNotification?: Partial<NotificationInterface>,
  ): Promise<NotificationInterface> {
    return APIService.Server.put<NotificationInterface>(`/notifications/org/${orgId}/notification/${notificationId}/acknowledge`, {
      updatedNotification,
    });
  }
}
